import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { useWithBreadcrumbsStyles } from '../styles';
import Breadcrumbs from '../../../components/Breadcrumbs';
import Link from '../../../components/Link';
import Grid from '@material-ui/core/Grid';
import { URL } from '../../../utils/constants/general';
import { useLocation } from 'react-router-dom';
import { CATEGORY_HIERARCHY } from '../../../utils/constants/category';

const withBreadcrumbs = WrappedPage => props => {
	const { t } = useTranslation();
	const classes = useWithBreadcrumbsStyles();
	const location = useLocation();
	const category = CATEGORY_HIERARCHY.categories.find(cat => cat.pathParam === location.pathname.split('/')[1]);

	return (
		<section className={classes.pagePadding}>
			{location.pathname === '/' ? (
				<Grid container direction="column" alignItems="center" component="section">
					<Grid item container className={classes.title} xs={12} sm={12} md={12} lg={11} xl={10}>
						<Breadcrumbs margin={props.margin} />
					</Grid>
				</Grid>
			) : (
				<Grid className={classes.categoryTitle}>
					<Typography variant="h6">
						{t('category:' + category.id + '.abbreviation') + ' - '}
						<Link noWrap underline="none" href={URL.PRT_PLUS} target="_self" style={{ fontSize: '1.125rem' }}>
							{t('components.header.title')}
						</Link>
					</Typography>
					<Breadcrumbs margin={props.margin} />
				</Grid>
			)}

			<WrappedPage {...props} />
		</section>
	);
};

export default withBreadcrumbs;
